import { render } from "./Alert.vue?vue&type=template&id=7d6c0efa&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=7d6c0efa&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6c0efa"]])

export default __exports__